import React from "react"

const IconMinus = () => (
  <svg
    data-name="Livello 1"
    id="iconminus"
    viewBox="0 0 128 128"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title />
    <path d="M64,0a64,64,0,1,0,64,64A64.07,64.07,0,0,0,64,0Zm0,122a58,58,0,1,1,58-58A58.07,58.07,0,0,1,64,122Z" />
    <path d="M90,61H38a3,3,0,0,0,0,6H90a3,3,0,0,0,0-6Z" />
  </svg>
)
const ScrollDownIcon = () => (
<svg id="MouseScroll" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46 46">
  <g id="Mouse-13" transform="translate(15.333 5.75)">
    <path id="Path_3" data-name="Path 3" d="M9.96,18.64l3.987,3.967,3.968-3.967" transform="translate(-6.721 13.062)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.25"/>
    <path id="Path_4" data-name="Path 4" d="M15.362,30.067h0A7.1,7.1,0,0,1,8.27,22.976V10.192A7.1,7.1,0,0,1,15.362,3.1h0a7.1,7.1,0,0,1,7.092,7.092V22.976A7.1,7.1,0,0,1,15.362,30.067Z" transform="translate(-8.27 -3.1)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.25"/>
    <line id="Line_1" data-name="Line 1" y2="4.849" transform="translate(7.092 3.929)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.25"/>
  </g>
</svg>
)
const WhitePlayIcon = () => (
<svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.6787 6.23204C9.15809 6.63182 9.15809 7.36823 8.67871 7.76801L1.79007 13.5128C1.13881 14.0559 0.149609 13.5928 0.149609 12.7448L0.149609 1.25525C0.149609 0.407241 1.13881 -0.0558596 1.79007 0.487259L8.6787 6.23204Z" fill="white"/>
</svg>
)

const ScrollDownIconWhite = () => (
  <svg id="MouseScroll" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46 46">
    <g id="Mouse-13" transform="translate(15.333 5.75)">
      <path id="Path_3" data-name="Path 3" d="M9.96,18.64l3.987,3.967,3.968-3.967" transform="translate(-6.721 13.062)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.25"/>
      <path id="Path_4" data-name="Path 4" d="M15.362,30.067h0A7.1,7.1,0,0,1,8.27,22.976V10.192A7.1,7.1,0,0,1,15.362,3.1h0a7.1,7.1,0,0,1,7.092,7.092V22.976A7.1,7.1,0,0,1,15.362,30.067Z" transform="translate(-8.27 -3.1)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.25"/>
      <line id="Line_1" data-name="Line 1" y2="4.849" transform="translate(7.092 3.929)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.25"/>
    </g>
  </svg>
  )
const IconArrow = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.49899 13.0001C9.43319 13.0005 9.36796 12.9879 9.30704 12.963C9.24612 12.9381 9.19071 12.9014 9.14399 12.8551C9.09713 12.8086 9.05993 12.7533 9.03455 12.6924C9.00916 12.6315 8.99609 12.5661 8.99609 12.5001C8.99609 12.4341 9.00916 12.3687 9.03455 12.3078C9.05993 12.2469 9.09713 12.1916 9.14399 12.1451L13.294 8.00009L9.14399 3.85509C9.04984 3.76094 8.99695 3.63324 8.99695 3.50009C8.99695 3.36694 9.04984 3.23924 9.14399 3.14509C9.23815 3.05094 9.36584 2.99805 9.49899 2.99805C9.63214 2.99805 9.75984 3.05094 9.85399 3.14509L14.354 7.64509C14.4009 7.69157 14.4381 7.74687 14.4634 7.8078C14.4888 7.86873 14.5019 7.93409 14.5019 8.00009C14.5019 8.0661 14.4888 8.13145 14.4634 8.19238C14.4381 8.25331 14.4009 8.30861 14.354 8.35509L9.85399 12.8551C9.80727 12.9014 9.75187 12.9381 9.69095 12.963C9.63003 12.9879 9.5648 13.0005 9.49899 13.0001Z"
      fill="#FAFAFA"
    />
    <path
      d="M14 8.5H2C1.86739 8.5 1.74021 8.44732 1.64645 8.35355C1.55268 8.25979 1.5 8.13261 1.5 8C1.5 7.86739 1.55268 7.74021 1.64645 7.64645C1.74021 7.55268 1.86739 7.5 2 7.5H14C14.1326 7.5 14.2598 7.55268 14.3536 7.64645C14.4473 7.74021 14.5 7.86739 14.5 8C14.5 8.13261 14.4473 8.25979 14.3536 8.35355C14.2598 8.44732 14.1326 8.5 14 8.5Z"
      fill="#FAFAFA"
    />
  </svg>
)
const EmailIcon = () => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle opacity="0.2" cx="32" cy="32" r="32" fill="#121212" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M21.75 23C20.7835 23 20 23.7835 20 24.75V38.75C20 39.7165 20.7835 40.5 21.75 40.5H42.25C43.2165 40.5 44 39.7165 44 38.75V24.75C44 23.7835 43.2165 23 42.25 23H21.75ZM21.5 24.75C21.5 24.6119 21.6119 24.5 21.75 24.5H42.25C42.3881 24.5 42.5 24.6119 42.5 24.75V25.6016L32.1399 32.6016C32.0554 32.6587 31.9446 32.6587 31.86 32.6016L21.5 25.6016V24.75ZM21.5 27.4119V38.75C21.5 38.8881 21.6119 39 21.75 39H42.25C42.3881 39 42.5 38.8881 42.5 38.75V27.4119L32.9797 33.8445C32.3878 34.2445 31.6122 34.2445 31.0202 33.8445L21.5 27.4119Z"
      fill="white"
    />
  </svg>
)
const MarkerIcon = () => (
  <svg
    width="24"
    height="39"
    viewBox="0 0 24 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.9994 0C5.3729 0 0 5.34362 0 11.934C0 21.2824 11.9994 29.9624 11.9994 38.5579C11.9994 29.9624 24 21.2824 24 11.934C24 5.34362 18.6271 0 11.9994 0Z"
      fill="#121212"
    />
  </svg>
)

const IconPhone = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.4375 5.03125H20.5625"
      stroke="#121212"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.5625 22.0938H7.4375"
      stroke="#121212"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.875 3.71875C14.875 3.47812 15.0719 3.28125 15.3125 3.28125C15.5531 3.28125 15.75 3.47812 15.75 3.71875C15.75 3.95938 15.5531 4.15625 15.3125 4.15625C15.0719 4.15625 14.875 3.95938 14.875 3.71875ZM13.5625 3.71875C13.5625 3.47812 13.7594 3.28125 14 3.28125C14.2406 3.28125 14.4375 3.47812 14.4375 3.71875C14.4375 3.95938 14.2406 4.15625 14 4.15625C13.7594 4.15625 13.5625 3.95938 13.5625 3.71875ZM12.25 3.71875C12.25 3.47812 12.4469 3.28125 12.6875 3.28125C12.9281 3.28125 13.125 3.47812 13.125 3.71875C13.125 3.95938 12.9281 4.15625 12.6875 4.15625C12.4469 4.15625 12.25 3.95938 12.25 3.71875Z"
      fill="#121212"
    />
    <path
      d="M12.6875 23.8438H15.3125"
      stroke="#121212"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.5625 23.8438C20.5625 24.8102 19.7789 25.5938 18.8125 25.5938H9.1875C8.22106 25.5938 7.4375 24.8102 7.4375 23.8438V4.15625C7.4375 3.18981 8.22106 2.40625 9.1875 2.40625H18.8125C19.7789 2.40625 20.5625 3.18981 20.5625 4.15625V23.8438Z"
      stroke="#121212"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
const WhiteMinus = () => (
  <svg
    height="512px"
    id="Layer_1"
    style="enable-background:new 0 0 512 512;"
    version="1.1"
    viewBox="0 0 512 512"
    width="512px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path d="M384,265H128v-17h256V265z" />
    </g>
  </svg>
)

const WhitePlus = () => (
  <svg
    enable-background="new 0 0 512 512"
    height="512px"
    id="Layer_1"
    version="1.1"
    viewBox="0 0 512 512"
    width="512px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <line
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        stroke-width="10"
        x1="256"
        x2="256"
        y1="180.3"
        y2="331.7"
      />
      <line
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        stroke-width="10"
        x1="331.7"
        x2="180.3"
        y1="256"
        y2="256"
      />
    </g>
  </svg>
)
const BackArrow = () => (
  <svg
    width="10"
    height="8"
    viewBox="0 0 10 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.87499 0.24993C3.92434 0.249645 3.97327 0.259104 4.01896 0.277766C4.06465 0.296427 4.1062 0.323925 4.14124 0.35868C4.17639 0.393541 4.20429 0.435017 4.22333 0.480714C4.24237 0.526411 4.25217 0.575426 4.25217 0.62493C4.25217 0.674435 4.24237 0.723449 4.22333 0.769146C4.20429 0.814844 4.17639 0.856318 4.14124 0.89118L1.02874 3.99993L4.14124 7.10868C4.21186 7.17929 4.25153 7.27507 4.25153 7.37493C4.25153 7.47479 4.21186 7.57057 4.14124 7.64118C4.07063 7.71179 3.97486 7.75146 3.87499 7.75146C3.77513 7.75146 3.67936 7.71179 3.60874 7.64118L0.233743 4.26618C0.198595 4.23132 0.170696 4.18984 0.151658 4.14415C0.132619 4.09845 0.122818 4.04943 0.122818 3.99993C0.122818 3.95043 0.132619 3.90141 0.151658 3.85571C0.170696 3.81002 0.198595 3.76854 0.233743 3.73368L3.60874 0.35868C3.64378 0.323925 3.68534 0.296427 3.73103 0.277766C3.77672 0.259104 3.82564 0.249645 3.87499 0.24993Z"
      fill="white"
    />
    <path
      d="M0.5 3.625L9.5 3.625C9.59946 3.625 9.69484 3.66451 9.76517 3.73483C9.83549 3.80516 9.875 3.90054 9.875 4C9.875 4.09946 9.83549 4.19484 9.76517 4.26516C9.69484 4.33549 9.59946 4.375 9.5 4.375L0.5 4.375C0.400544 4.375 0.305161 4.33549 0.234835 4.26516C0.164509 4.19484 0.125 4.09946 0.125 4C0.125 3.90054 0.164509 3.80516 0.234835 3.73483C0.305161 3.66451 0.400544 3.625 0.5 3.625Z"
      fill="white"
    />
  </svg>
)

const PrintIcon = () => (
  <svg
    width="23"
    height="21"
    viewBox="0 0 23 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.26562 7.84494V1.37695H12.9304M17.7329 5.52531V7.84494V5.52531Z"
      stroke="#121212"
      stroke-miterlimit="6.2"
      stroke-linejoin="round"
    />
    <path
      d="M17.5662 5.66869H12.9297C12.8377 5.66869 12.7637 5.60474 12.7637 5.52532V1.52033C12.7637 1.4409 12.8377 1.37695 12.9297 1.37695L17.7322 5.52532C17.7322 5.60474 17.6581 5.66869 17.5662 5.66869V5.66869Z"
      stroke="#121212"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.5713 9.63232H20.0932"
      stroke="#121212"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.33509 14.6079H1V7.95605H22V14.6079H18.0026"
      stroke="#121212"
      stroke-linejoin="round"
    />
    <path
      d="M7.8999 15.3986H15.1017"
      stroke="#121212"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.8999 17.3441H15.1017"
      stroke="#121212"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.8331 13.2205H5.16553V19.52H17.8331V13.2205Z"
      stroke="#121212"
      stroke-linejoin="round"
    />
  </svg>
)

const ShareIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.9123 14.5436C1.9873 14.5436 0.456055 13.0124 0.456055 11.0874C0.456055 9.16236 1.9873 7.6311 3.9123 7.6311C5.8373 7.6311 7.36856 9.16236 7.36856 11.0874C7.36856 12.9686 5.8373 14.5436 3.9123 14.5436ZM3.9123 8.89986C2.73105 8.89986 1.76855 9.86236 1.76855 11.0436C1.76855 12.2249 2.73105 13.1874 3.9123 13.1874C5.09355 13.1874 6.05606 12.2249 6.05606 11.0436C6.05606 9.90611 5.09355 8.89986 3.9123 8.89986Z"
      fill="#121212"
    />
    <path
      d="M17.9562 7.50002C16.0312 7.50002 14.5 5.96877 14.5 4.04377C14.5 2.11877 16.0312 0.587524 17.9562 0.587524C19.8812 0.587524 21.4125 2.11877 21.4125 4.04377C21.4125 5.96877 19.8375 7.50002 17.9562 7.50002ZM17.9562 1.90003C16.775 1.90003 15.8125 2.86252 15.8125 4.04377C15.8125 5.22502 16.775 6.18752 17.9562 6.18752C19.1375 6.18752 20.1 5.22502 20.1 4.04377C20.1 2.86252 19.1375 1.90003 17.9562 1.90003Z"
      fill="#121212"
    />
    <path
      d="M17.9562 21.5436C16.0312 21.5436 14.5 20.0124 14.5 18.0874C14.5 16.1624 16.0312 14.6311 17.9562 14.6311C19.8812 14.6311 21.4125 16.1624 21.4125 18.0874C21.4125 20.0124 19.8375 21.5436 17.9562 21.5436ZM17.9562 15.9436C16.775 15.9436 15.8125 16.9061 15.8125 18.0874C15.8125 19.2686 16.775 20.2311 17.9562 20.2311C19.1375 20.2311 20.1 19.2686 20.1 18.0874C20.1 16.9061 19.1375 15.9436 17.9562 15.9436Z"
      fill="#121212"
    />
    <path
      d="M15.1121 17.4751L6.09961 12.9688L6.71212 11.7001L15.7684 16.2063L15.1121 17.4751Z"
      fill="#121212"
    />
    <path
      d="M6.71212 10.4313L6.09961 9.20632L15.1121 4.70007L15.7684 5.92507L6.71212 10.4313Z"
      fill="#121212"
    />
  </svg>
)

const IconZoom = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.712 15.9131L11.087 10.2881C11.9997 9.17054 12.448 7.74498 12.3392 6.30619C12.2305 4.8674 11.573 3.52542 10.5027 2.55772C9.43246 1.59002 8.03124 1.07061 6.5888 1.10688C5.14637 1.14316 3.77303 1.73235 2.75275 2.75263C1.73247 3.77291 1.14328 5.14625 1.107 6.58868C1.07073 8.03112 1.59014 9.43233 2.55784 10.5026C3.52554 11.5729 4.86752 12.2304 6.30631 12.3391C7.7451 12.4478 9.17066 11.9995 10.2882 11.0869L15.9132 16.7119L16.712 15.9131ZM2.2501 6.74998C2.2501 5.85996 2.51402 4.98993 3.00849 4.24991C3.50295 3.50989 4.20576 2.93312 5.02803 2.59252C5.85029 2.25193 6.75509 2.16281 7.62801 2.33645C8.50092 2.51008 9.30275 2.93866 9.93208 3.568C10.5614 4.19733 10.99 4.99916 11.1636 5.87207C11.3373 6.74499 11.2482 7.64979 10.9076 8.47205C10.567 9.29432 9.99019 9.99713 9.25017 10.4916C8.51015 10.9861 7.64012 11.25 6.7501 11.25C5.55663 11.25 4.41203 10.7759 3.56812 9.93196C2.72421 9.08805 2.2501 7.94345 2.2501 6.74998Z"
      fill="white"
    />
    <path
      d="M7.3125 3.9375H6.1875V6.1875H3.9375V7.3125H6.1875V9.5625H7.3125V7.3125H9.5625V6.1875H7.3125V3.9375Z"
      fill="white"
    />
  </svg>
)

const Close = () => (
  <svg
    enable-background="new 0 0 24 24"
    id="Layer_1"
    version="1.0"
    viewBox="0 0 24 24"
    xml="preserve"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path d="M12,2C6.5,2,2,6.5,2,12c0,5.5,4.5,10,10,10s10-4.5,10-10C22,6.5,17.5,2,12,2z M16.9,15.5l-1.4,1.4L12,13.4l-3.5,3.5   l-1.4-1.4l3.5-3.5L7.1,8.5l1.4-1.4l3.5,3.5l3.5-3.5l1.4,1.4L13.4,12L16.9,15.5z" />
    </g>
  </svg>
)

const StarLogo = () => (
  <svg
    width="91"
    height="21"
    viewBox="0 0 91 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M91 7.15338H88.9966L86.7986 15.0498C86.8027 14.9775 86.8027 14.905 86.7986 14.8327C86.7968 14.4967 86.7506 14.1624 86.6612 13.8385L84.8753 7.15338H82.8147C82.8147 7.15338 85.7797 17.0611 86.043 17.2439C85.6652 18.3867 85.2875 18.9695 84.5777 19.278L85.276 20.4208C86.3358 20.1201 87.1741 19.309 87.5084 18.261L91 7.15338ZM80.6968 6.98168C79.8422 6.93396 79.0478 7.42155 78.7049 8.20443C78.6068 7.72958 78.3169 7.31614 77.9035 7.06167L76.6213 7.82732C76.9678 8.17236 77.1616 8.64149 77.1594 9.13006V17.1294H78.9682V10.4214C78.9676 10.0071 79.1377 9.61074 79.4387 9.32544C79.7397 9.04014 80.145 8.89096 80.5594 8.91294C80.9666 8.91181 81.3649 9.0311 81.7042 9.25576L82.2766 7.49592C81.7949 7.17346 81.2309 6.99505 80.651 6.98168H80.6968ZM74.4233 6.98181C73.5678 6.93069 72.7717 7.41939 72.4314 8.20456C72.3172 7.73682 72.0312 7.32895 71.63 7.0618L70.3478 7.82745C70.6986 8.1706 70.8965 8.63997 70.8973 9.13019V17.1295H72.7176V10.4215C72.7173 10.0113 72.8843 9.61875 73.1802 9.33416C73.4761 9.04957 73.8754 8.89753 74.2859 8.91307C74.6931 8.91194 75.0915 9.03123 75.4307 9.25589L75.9803 7.49605C75.5064 7.17484 74.9501 6.99634 74.3775 6.98181H74.4233ZM65.4596 8.5932C65.8753 8.58089 66.2785 8.7364 66.578 9.02458C66.8775 9.31276 67.0479 9.70928 67.0508 10.1245V11.1073H63.6851V10.2388C63.6631 9.77866 63.8423 9.33168 64.1762 9.01373C64.5101 8.69577 64.9658 8.53817 65.4252 8.58177L65.4596 8.5932ZM65.5168 6.98173C63.4447 6.98173 61.8534 8.01022 61.8534 10.2157V13.8611C61.8101 14.8094 62.1791 15.7302 62.8657 16.387C63.5522 17.0438 64.4894 17.3728 65.4367 17.2894C66.6785 17.3103 67.8902 16.9071 68.8711 16.1466L68.1269 14.6268C67.383 15.2494 66.4526 15.6072 65.4825 15.6438C64.9696 15.6688 64.4722 15.4649 64.1249 15.0873C63.7776 14.7098 63.6165 14.1977 63.6851 13.6897V12.7069H68.894V10.4214C68.9863 9.49007 68.6579 8.5661 67.9983 7.901C67.3386 7.23591 66.4164 6.89891 65.4825 6.98173H65.5168ZM54.7443 4.06775H52.9355V15.4039C52.9417 15.8324 52.6751 16.2178 52.2715 16.3638L53.1988 17.3466C53.5997 17.25 53.9601 17.0301 54.2291 16.7181C54.9292 17.105 55.7186 17.302 56.5187 17.2895C57.4405 17.3819 58.3593 17.087 59.0544 16.4756C59.7494 15.8641 60.158 14.9914 60.182 14.0669V10.1929C60.258 9.31204 59.937 8.44313 59.3063 7.82238C58.6756 7.20162 57.8007 6.89351 56.9194 6.98178C56.1512 6.99735 55.3992 7.20563 54.7328 7.58744L54.7443 4.06775ZM56.7705 8.6388C57.1998 8.60998 57.6201 8.77095 57.92 9.07903C58.2198 9.3871 58.3688 9.81114 58.3275 10.2387V14.1583C58.3169 14.6159 58.1159 15.0485 57.7727 15.3521C57.4294 15.6557 56.9751 15.8028 56.5187 15.7582C55.8854 15.7809 55.2609 15.6051 54.7328 15.2554V9.33589C55.3236 8.86099 56.0578 8.59925 56.8163 8.59309L56.7705 8.6388ZM50.2337 6.98169C49.3775 6.93904 48.5826 7.42425 48.2303 8.20444C48.1363 7.73102 47.8505 7.31745 47.4404 7.06168L46.1697 7.82733C46.513 8.17449 46.7062 8.64225 46.7078 9.13007V17.1294H48.528V10.4214C48.527 10.0029 48.7003 9.60272 49.0064 9.31669C49.3125 9.03065 49.7239 8.88441 50.1422 8.91295C50.5493 8.91182 50.9477 9.03111 51.287 9.25578L51.8365 7.49593C51.3626 7.17472 50.8063 6.99622 50.2337 6.98169ZM40.9609 6.98186C39.6425 6.90616 38.367 7.46217 37.5265 8.47888L38.4996 9.70163C39.0275 8.9674 39.8839 8.53994 40.7892 8.55887C41.2272 8.51936 41.6601 8.67681 41.97 8.98837C42.2799 9.29993 42.4346 9.73317 42.3919 10.1702V11.1301H40.6518C39.7521 11.0531 38.8614 11.3571 38.1973 11.9678C37.5332 12.5786 37.1568 13.4399 37.1601 14.3412C37.158 14.7326 37.2319 15.1207 37.3777 15.484C37.9067 16.7138 39.1674 17.4652 40.503 17.3467C41.3219 17.3459 42.121 17.0946 42.7925 16.6267C43.0619 16.9784 43.4278 17.2444 43.8458 17.3924L44.8875 16.5239C44.5137 16.1979 44.2834 15.7381 44.2464 15.244V10.273C44.3078 9.38479 43.9818 8.51342 43.3522 7.88277C42.7227 7.25213 41.8509 6.9237 40.9609 6.98186ZM42.4377 12.6957V15.0383C41.9418 15.4471 41.3282 15.6873 40.6861 15.724C40.4999 15.7257 40.3146 15.6987 40.1366 15.644C39.5018 15.4805 39.0617 14.9042 39.072 14.2498C39.0896 13.8161 39.2817 13.4078 39.605 13.1174C39.9282 12.827 40.3552 12.6791 40.7892 12.7071L42.4377 12.6957ZM33.9204 4.15912L32.0658 4.90191V7.18743H30.7378V8.67301H32.0543V15.0267C32.0543 16.8323 33.0389 17.3123 33.9204 17.3123C34.649 17.3589 35.3673 17.1213 35.9238 16.6495L35.4429 15.1182C35.2143 15.4 34.8782 15.574 34.5157 15.5981C34.3453 15.6096 34.1787 15.5446 34.0613 15.4208C33.9439 15.297 33.888 15.1274 33.9089 14.9582V8.67301H36.0611L36.3473 7.15315H33.9204V4.15912ZM26.1586 3.87353C23.8118 3.87353 22.2091 5.26769 22.2091 7.23323C22.2801 8.86455 23.3214 10.2954 24.8536 10.8672C25.8018 11.248 26.677 11.7892 27.4408 12.4671C27.7494 12.8081 27.9172 13.2532 27.9102 13.7127C27.9091 14.2703 27.6721 14.8015 27.2576 15.1754C26.7612 15.5194 26.1674 15.6956 25.5633 15.6782C24.5734 15.6394 23.6339 15.2317 22.9303 14.5355L21.8427 15.9068C22.8298 16.9007 24.1983 17.4214 25.5977 17.3352C27.3796 17.4881 29.0473 16.4436 29.6846 14.7754C29.7921 14.4471 29.8462 14.1038 29.8449 13.7584C29.8435 13.1809 29.7021 12.6124 29.4328 12.1014C29.0007 11.3093 28.3488 10.6586 27.5553 10.2273C26.4105 9.5416 24.1209 8.83309 24.1209 7.27894C24.1307 6.79053 24.3461 6.32882 24.7142 6.00698C25.0824 5.68514 25.5693 5.53293 26.0556 5.58766C26.9529 5.5736 27.811 5.95385 28.4024 6.62757L29.4786 5.3134C28.6314 4.37177 27.4148 3.84594 26.1472 3.87353H26.1586ZM14.516 4.5706L14.31 4.86772C14.2505 4.95622 14.215 5.05858 14.2069 5.16484C14.2173 5.27259 14.271 5.37155 14.3558 5.4391C14.7239 5.75625 15.1467 6.00406 15.6036 6.17046L15.9928 6.33045C15.5987 5.6683 15.1 5.07403 14.516 4.5706ZM9.93685 2.78794C10.4527 3.13592 11.039 3.36612 11.654 3.46216H11.8601C12.0515 3.46415 12.239 3.40839 12.3982 3.30218C11.6178 3.00286 10.7947 2.82928 9.95974 2.78794H9.93685ZM8.73481 3.03941C8.67445 3.07279 8.63239 3.13157 8.62033 3.19939C8.62033 3.39366 8.88363 3.61078 8.88363 3.61078C9.08389 3.7673 9.21196 3.99823 9.23852 4.25073C9.23852 4.63927 8.86074 5.11922 7.33816 5.49633C7.33816 5.49633 5.71254 5.80488 5.71254 6.36483C5.71254 6.60481 5.90716 6.6848 6.19336 6.6848C6.52252 6.6912 6.85168 6.6721 7.17788 6.62766C7.55246 6.53265 7.93637 6.479 8.32268 6.46768C9.18128 6.46768 10.1887 6.87907 10.3833 8.91318C10.3833 8.91318 10.4635 10.6273 10.8069 10.7302C11.1503 10.833 11.1847 10.0331 11.4136 9.09602C11.5739 8.36465 12.2035 6.98192 13.5773 6.98192C14.0207 6.9942 14.4553 7.10756 14.848 7.31332C15.3264 7.59858 15.8485 7.80321 16.3935 7.91898C16.4965 7.91898 16.5767 7.91898 16.611 7.81613C16.6454 7.71328 16.84 7.33617 15.3403 6.67337C14.2985 6.2277 13.5201 5.7706 13.5201 5.11922C13.542 4.82181 13.6629 4.54024 13.8635 4.31929C13.986 4.18696 14.0623 4.01857 14.081 3.83934C14.0863 3.76978 14.066 3.70067 14.0238 3.64507C13.9554 3.55814 13.848 3.51099 13.7376 3.51936C13.3987 3.57431 13.0773 3.70734 12.7988 3.9079C12.5282 4.07526 12.2123 4.15508 11.8945 4.13645C11.0599 4.08888 10.2604 3.7856 9.60486 3.26796C9.43156 3.12678 9.22062 3.03938 8.99811 3.01655C8.90987 3.00064 8.81897 3.00853 8.73481 3.03941ZM7.77318 3.03939C4.3961 3.71546 1.92729 6.61978 1.80878 10.0559C1.81179 10.3926 1.83857 10.7286 1.88892 11.0616C2.51673 14.6045 5.64688 17.1556 9.24997 17.061C9.6599 17.0588 10.0692 17.0283 10.4749 16.9696C14.1269 16.5158 16.9048 13.4763 17.0231 9.80452C17.0204 9.47163 16.9936 9.13937 16.943 8.81032V8.66176C16.8448 8.68146 16.7436 8.68146 16.6454 8.66176C15.8806 8.57588 15.1389 8.34716 14.4588 7.98753C14.1807 7.85079 13.8758 7.77667 13.5659 7.77041C13.3822 7.76556 13.1995 7.79662 13.0278 7.86183C12.3791 8.35113 11.9642 9.08834 11.883 9.89594C11.8459 10.3729 11.7177 10.8384 11.5052 11.2672C11.3359 11.5047 11.0644 11.6486 10.7726 11.6558C10.497 11.651 10.2375 11.5257 10.0628 11.313C9.76032 10.6896 9.60374 10.0058 9.60486 9.31313C9.60486 9.09601 9.51327 7.86183 8.87219 7.43901C8.63872 7.30756 8.37295 7.2442 8.10517 7.25617C7.49316 7.31429 6.88529 7.4097 6.28494 7.54186H5.9415C5.45489 7.58391 4.99514 7.31314 4.7967 6.86763C4.74783 6.76822 4.72424 6.65833 4.72802 6.54766C4.73747 6.27085 4.84731 6.00689 5.03711 5.80487C5.73893 5.28879 6.55629 4.95145 7.41829 4.8221C7.72839 4.75344 8.02079 4.62112 8.27689 4.43356C8.35703 4.37642 8.39137 4.35357 8.39137 4.33071C8.39137 4.30786 8.29979 4.22786 8.12807 4.02217C7.91724 3.82898 7.78654 3.56398 7.76173 3.27937C7.76569 3.17802 7.78499 3.07785 7.81897 2.98226L7.77318 3.03939ZM11.4709 2.21656C10.8705 2.10643 10.2611 2.05286 9.65065 2.05658C8.63605 2.05309 7.62739 2.21126 6.66272 2.52511C2.83302 3.68491 0.159107 7.1383 0 11.1301C0.00167789 11.9055 0.121339 12.6761 0.354887 13.4156C1.0195 15.4395 2.47172 17.1115 4.38458 18.0552C5.76358 18.788 7.29859 19.1799 8.86074 19.1979C9.83968 19.1993 10.8129 19.049 11.7456 18.7523C15.6254 17.6116 18.317 14.0924 18.3969 10.0559C18.3986 9.31437 18.2984 8.57614 18.0993 7.86178C17.7791 6.75939 17.2069 5.74623 16.4279 4.90204C15.9075 4.3974 15.3445 3.9386 14.745 3.53073C14.7546 3.61808 14.7546 3.70622 14.745 3.79357V3.87356C15.9555 4.76437 16.8563 6.01116 17.3208 7.43896C17.5757 8.1739 17.7034 8.94677 17.6986 9.72448C17.6981 10.9535 17.3913 12.1631 16.8056 13.2442C15.7043 15.2726 13.8443 16.7843 11.6311 17.4495C10.7682 17.7216 9.86871 17.8604 8.96377 17.8609C5.52476 17.9528 2.42392 15.8059 1.30507 12.5585C1.08859 11.8709 0.980457 11.1538 0.984526 10.433C1.10228 6.80246 3.55379 3.66273 7.05196 2.66224C7.52596 2.51465 8.01269 2.41136 8.50585 2.35369H8.7577H9.65065C10.8489 2.34546 12.0365 2.57866 13.1423 3.03935L13.314 2.91365V2.79937C12.7269 2.52781 12.1075 2.33197 11.4709 2.21656Z"
      fill="white"
    ></path>
  </svg>
)
const DownArrow = () => (
  <svg
    id="Layer_1"
    version="1.1"
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <g id="Icon-Chevron-Left" transform="translate(237.000000, 335.000000)">
        <polyline
          class="st0"
          id="Fill-35"
          points="-218.7,-308.6 -216.7,-310.6 -205,-298.8 -193.3,-310.6 -191.3,-308.6 -205,-294.9      -218.7,-308.6    "
        />
      </g>
    </g>
  </svg>
)

const TikTok = () => (
  <svg
    height="25"
    viewBox="0 0 250 250"
    width="25"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-rule="evenodd" fill-rule="evenodd">
      <path
        d="M25 0h200c13.808 0 25 11.192 25 25v200c0 13.808-11.192 25-25 25H25c-13.808 0-25-11.192-25-25V25C0 11.192 11.192 0 25 0z"
        fill="#010101"
      />
      <path
        d="M156.98 230c7.607 0 13.774-6.117 13.774-13.662s-6.167-13.663-13.774-13.663h-2.075c7.607 0 13.774 6.118 13.774 13.663S162.512 230 154.905 230z"
        fill="#ee1d51"
      />
      <path
        d="M154.717 202.675h-2.075c-7.607 0-13.775 6.118-13.775 13.663S145.035 230 152.642 230h2.075c-7.608 0-13.775-6.117-13.775-13.662s6.167-13.663 13.775-13.663z"
        fill="#66c8cf"
      />
      <ellipse cx="154.811" cy="216.338" fill="#010101" rx="6.699" ry="6.643" />
      <path
        d="M50 196.5v6.925h8.112v26.388h8.115v-26.201h6.603l2.264-7.112zm66.415 0v6.925h8.112v26.388h8.115v-26.201h6.603l2.264-7.112zm-39.81 3.93c0-2.17 1.771-3.93 3.959-3.93 2.19 0 3.963 1.76 3.963 3.93s-1.772 3.93-3.963 3.93c-2.188-.001-3.959-1.76-3.959-3.93zm0 6.738h7.922v22.645h-7.922zM87.924 196.5v33.313h7.925v-8.608l2.453-2.248L106.037 230h8.49l-11.133-16.095 10-9.733h-9.622l-7.923 7.86V196.5zm85.47 0v33.313h7.926v-8.608l2.452-2.248L191.509 230H200l-11.133-16.095 10-9.733h-9.622l-7.925 7.86V196.5z"
        fill="#fff"
      />
      <path
        d="M161.167 81.186c10.944 7.819 24.352 12.42 38.832 12.42V65.755a39.26 39.26 0 0 1-8.155-.853v21.923c-14.479 0-27.885-4.601-38.832-12.42v56.835c0 28.432-23.06 51.479-51.505 51.479-10.613 0-20.478-3.207-28.673-8.707C82.187 183.57 95.23 189.5 109.66 189.5c28.447 0 51.508-23.047 51.508-51.48V81.186zm10.06-28.098c-5.593-6.107-9.265-14-10.06-22.726V26.78h-7.728c1.945 11.09 8.58 20.565 17.788 26.308zm-80.402 99.107a23.445 23.445 0 0 1-4.806-14.256c0-13.004 10.548-23.547 23.561-23.547a23.6 23.6 0 0 1 7.147 1.103V87.022a51.97 51.97 0 0 0-8.152-.469v22.162a23.619 23.619 0 0 0-7.15-1.103c-13.013 0-23.56 10.543-23.56 23.548 0 9.195 5.272 17.157 12.96 21.035z"
        fill="#ee1d52"
      />
      <path
        d="M153.012 74.405c10.947 7.819 24.353 12.42 38.832 12.42V64.902c-8.082-1.72-15.237-5.942-20.617-11.814-9.208-5.743-15.843-15.218-17.788-26.308H133.14v111.239c-.046 12.968-10.576 23.468-23.561 23.468-7.652 0-14.45-3.645-18.755-9.292-7.688-3.878-12.96-11.84-12.96-21.035 0-13.005 10.547-23.548 23.56-23.548 2.493 0 4.896.388 7.15 1.103V86.553c-27.945.577-50.42 23.399-50.42 51.467 0 14.011 5.597 26.713 14.68 35.993 8.195 5.5 18.06 8.707 28.673 8.707 28.445 0 51.505-23.048 51.505-51.479z"
        fill="#fff"
      />
      <path
        d="M191.844 64.902v-5.928a38.84 38.84 0 0 1-20.617-5.887 38.948 38.948 0 0 0 20.617 11.815zM153.439 26.78a39.524 39.524 0 0 1-.427-3.198V20h-28.028v111.24c-.045 12.967-10.574 23.467-23.56 23.467-3.813 0-7.412-.904-10.6-2.512 4.305 5.647 11.103 9.292 18.755 9.292 12.984 0 23.515-10.5 23.561-23.468V26.78zm-44.864 59.773v-6.311a51.97 51.97 0 0 0-7.067-.479C73.06 79.763 50 102.811 50 131.24c0 17.824 9.063 33.532 22.835 42.772-9.083-9.28-14.68-21.982-14.68-35.993 0-28.067 22.474-50.889 50.42-51.466z"
        fill="#69c9d0"
      />
      <path
        d="M154.904 230c7.607 0 13.775-6.117 13.775-13.662s-6.168-13.663-13.775-13.663h-.188c-7.607 0-13.774 6.118-13.774 13.663S147.109 230 154.716 230zm-6.792-13.662c0-3.67 3-6.643 6.7-6.643 3.697 0 6.697 2.973 6.697 6.643s-3 6.645-6.697 6.645c-3.7-.001-6.7-2.975-6.7-6.645z"
        fill="#fff"
      />
    </g>
  </svg>
)

export {
  IconMinus,
  IconArrow,
  EmailIcon,
  MarkerIcon,
  IconPhone,
  WhiteMinus,
  WhitePlus,
  BackArrow,
  PrintIcon,
  ShareIcon,
  IconZoom,
  Close,
  StarLogo,
  DownArrow,
  TikTok,
  ScrollDownIcon,
  ScrollDownIconWhite,
  WhitePlayIcon
}
